import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VChip,
    {
      staticClass: "my-2",
      attrs: { color: "bg-gray-0", "text-color": "primary" },
      on: { click: _setup.openMap },
    },
    [
      _c(VIcon, { staticClass: "mr-2", attrs: { size: "20" } }, [
        _vm._v("\n    ui-icon-map-full\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-button-small" }, [
        _vm._v(
          "\n    " + _vm._s(_setup.t("На карте", _setup.options)) + "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }